import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    mt2: {
        marginTop: theme.spacing(2),
    },
}));
